import Box from '@totallymoney/ui/components/Box'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'
import theme from '@totallymoney/ui/theme'

interface CardMinimumCreditLimitHighlightProps {
    description: string
    title: string
    variant: 'gcl' | 'totallysure'
}

const CardMinimumCreditLimitHighlight = ({
    variant,
    title,
    description,
}: CardMinimumCreditLimitHighlightProps) => {
    return (
        <Box
            borderRadius="borderRadius10"
            display="inline-flex"
            py="space10"
            px="space20"
            backgroundColor="eligibilityLevel0-100"
            justifyContent="center"
            flexDirection={['column', 'row']}
        >
            {variant === 'totallysure' ? (
                <Box
                    display="flex"
                    flexDirection={['column', 'column', 'row']}
                    alignItems={['flex-start', 'center']}
                >
                    <Box display="flex" alignItems="center" pr="space10">
                        <Text
                            variant="120"
                            weight="bold"
                            color="white"
                            style={{ fontFamily: theme.buenosAires }}
                        >
                            {title}
                        </Text>
                    </Box>
                    <Box mt="space025">
                        <Text variant="80" color="white">
                            {description}
                        </Text>
                    </Box>
                </Box>
            ) : null}
            {variant === 'gcl' ? (
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Box pr="space10" display="flex" alignItems="center">
                        <Icon icon="checkmark" size={16} color="white" />
                    </Box>

                    <Text
                        variant="80"
                        weight="bold"
                        style={{ fontFamily: theme.buenosAires }}
                        color="white"
                    >
                        {title}
                    </Text>
                </Box>
            ) : null}
        </Box>
    )
}

export default CardMinimumCreditLimitHighlight
